module.exports = {
	"processors": {
		"update_success": "Processor successfully updated",
		"details": "Details",
		"page_title": "Processors",
		"name": "Code name",
		"title": "Title",
		"status": "Status",
		"jurisdictions": "Jurisdictions",
		"actions": "Actions",
		"url": "URL",
		"deposit_systems": "Supported deposit systems",
		"withdraw_systems": "Supported withdraw systems",
		"reports_timezone": "Reports timezone",
		"active": "Active",
		"edit": "Edit",
		"invalid_name": "Please enter a valid project code name",
		"invalid_title": "Please enter a valid project title",
		"invalid_url": "Please enter a valid URL",
		"refunds_mode": "Refunds mode",
		"code": "Code",
		"rules": "Rules",
		"settings_link": "Settings of {name}",
		"comment": "Comment",
		"autorefund": "Autorefunds enabled",
		"skip_balance": "Skip balances update",
		"skip_callback": "Skip callbacks processing",
		"skip_check_status": "Skip check status requests",
		"allow_crypto_exchange": "Allow crypto auto exchange",
		"allow_ipv6": "Allow IPv6"
	}
};